import axios from 'core/common/config/axios-config';
import {IDomainObject} from "core/form/formUtils";

export interface EmpAttendanceDto {
  partyId: number;
  coming: boolean;
}

class EmployeeService {



  employeeAttendanceSave(empAttendanceDto: EmpAttendanceDto): Promise<IDomainObject> {
    console.log('employeeAttendanceSave %O', empAttendanceDto);
    return axios.post('/employee-attendance', empAttendanceDto)
      .then((response) => response.data);
  }




}

export default new EmployeeService();




// WEBPACK FOOTER //
// ./src/humanresource/employeeService.ts